import { USER_AGENT_UPDATE } from '../actionConstants';
import { getUserAgent } from '../../util/userAgent';
import { Action } from '../../generalTypes';

type DeviceScreenMode = {
  orientation: string;
  deviceType: string;
};

export const actionUpdateUserAgent = (): Action<DeviceScreenMode> => {
  const { orientation, deviceType } = getUserAgent();

  return {
    type: USER_AGENT_UPDATE,
    payload: {
      orientation,
      deviceType,
    },
  };
};
